import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

export const exportToExcel = (options) => {
  try {
    const { data, columns, fileName = 'export', sheetName = 'Sheet1' } = options;
    
    // Prepare the data for Excel
    const excelData = data.map(item => {
      const row = {};
      columns.forEach(col => {
        row[col.header] = item[col.key];
      });
      return row;
    });

    // Create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    
    // Add worksheet to workbook and save
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
    
  } catch (error) {
    console.error('Excel export error:', error);
    throw error;
  }
};

export const exportToPDF = (options) => {
  try {
    const { data, columns, fileName = 'export', title = 'Export' } = options;
    
    // Create new PDF document
    const doc = new jsPDF();
    
    // Add title
    doc.text(title, 14, 10);
    
    // Prepare table data
    const headers = columns.map(col => col.header);
    const body = data.map(item => 
      columns.map(col => item[col.key] || '')
    );
    
    // Add table
    doc.autoTable({
      head: [headers],
      body: body,
      startY: 20,
      styles: { overflow: 'linebreak' },
      columnStyles: {
        0: { cellWidth: 'auto' },
        1: { cellWidth: 'auto' },
        // Add more column styles if needed
      }
    });
    
    // Save the PDF
    doc.save(`${fileName}.pdf`);
    
  } catch (error) {
    console.error('PDF export error:', error);
    throw error;
  }
};